module.exports = __webpack_public_path__ + "static/media/hourseracing.d9be64b7.svg";